import React, { useEffect } from 'react';
import Shared from 'screens/shared';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { createLink, extractServerId } from 'utils';
import { ROUTE } from 'constant';
import CreateForm from './create';

export default ({
  nicsList = [], history = {}, showTarget = false, dcId, id,
}) => {
  useEffect(() => {
    if (showTarget) actions.dataCenter.get({ id: dcId });
  }, [showTarget, dcId]);

  const clickHandler = (e) => {
    history.push(createLink(ROUTE.DASHBOARD.NIC, { dcId, serverId: extractServerId(e?.href), id: e?.id }));
  };

  const deleteHandler = (e) => {
    actions.loadbalancer.deattachNic({ dcId, id, nicId: e?.id });
  };

  return (
    <Shared.widgets.Section
      itemIcon="server"
      sectionTitle="NICs"
      className="-m-t-24"
      createForm={<CreateForm {...{ dcId, id }} />}
      createActionType={ACTIONS_TYPES.LOAD_BALANCER.ATTACH_NIC}
      itemOnClick={(e) => clickHandler(e)}
      itemOnDelete={(e) => deleteHandler(e)}
      setItemTitle={(e) => e?.properties?.name}
      setItemDetails={(e) => e?.properties?.ips?.join?.(', ')}
      items={nicsList}
      isDeletePassword
    />
  );
};
